module.exports = __webpack_public_path__ + "static/media/repair_tail_wheel.99920de0.jpg";